import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, { Arrow, bookingHref, useMarketingCopy } from "./MarketingShell";
import DatedTimeline from "./DatedTimeline";
import narrative from "./siteNarrativeCopy.json";
import founderCopy from "./founderStoryCopy.json";
import "./CompanyNarrative.css";
import "./FounderPage.css";

export default function StoryPage() {
  const { language } = useMarketingCopy();
  const copy = (narrative[language] ?? narrative.en).story;
  const founder = founderCopy[language] ?? founderCopy.en;
  return <MarketingShell active="story">
    <SEOHead title={`${copy.title} ${copy.accent} — YouWo`} description={copy.description} canonicalUrl="https://youwo.ai/story"
      structuredData={{ "@context": "https://schema.org", "@type": "AboutPage", name: "The YouWo story", description: copy.description, url: "https://youwo.ai/story" }} />
    <main id="main-content" tabIndex={-1} className="company-story">
      <header className="quant-wrap story-hero"><p className="narrative-label">{copy.label}</p><h1>{copy.title}{" "}<br /><em>{copy.accent}</em></h1><p>{copy.description}</p><a className="quant-text-link" href="#next-chapter">{copy.nextLink}<Arrow diagonal /></a></header>
      <section className="quant-wrap narrative-split story-journey" aria-labelledby="story-journey-title">
        <div className="narrative-aside"><p className="narrative-label">{copy.timelineLabel}</p><h2 id="story-journey-title">{copy.introTitle}</h2><p>{copy.introText}</p><a className="quant-text-link" href="/blog#case-studies">{copy.caseLink}<Arrow /></a></div>
        <DatedTimeline entries={copy.events} label={copy.timelineLabel} />
      </section>
      <section className="quant-wrap story-founder-preview" aria-labelledby="story-founder-title">
        <div><p className="narrative-label">{founder.label}</p><h2 id="story-founder-title">{founder.title}</h2></div>
        <div><p>{founder.lead}</p><a className="quant-text-link" href="/founder">{founder.readLink}<Arrow /></a></div>
      </section>
      <section id="next-chapter" className="quant-wrap narrative-invitation"><p className="narrative-label">{copy.nextLabel}</p><h2>{copy.nextTitle}</h2><p>{copy.nextText}</p><div className="quant-cta-row"><a className="quant-button" href={bookingHref} target="_blank" rel="noopener noreferrer">{copy.nextLink}<Arrow diagonal /></a><a className="quant-text-link" href="/mission#milestones">{copy.roadmapLink}<Arrow /></a></div></section>
    </main>
  </MarketingShell>;
}
